import { useMemo, useState, type Dispatch, type SetStateAction } from 'react';

import type { Data, Inputs } from './types.ts';

const useFormData = <T extends string>(
  inputs: Inputs<T>,
  initialData: Partial<Data<T>>
): [Data<T>, Dispatch<SetStateAction<Data<T>>>] => {
  const emptyData = useMemo(
    () =>
      inputs.reduce((sum, cur) => {
        sum[cur[0]] = '';
        return sum;
      }, {} as Data<T>),
    [inputs]
  );

  const [formData, setFormData] = useState<Data<T>>({
    ...emptyData,
    ...initialData,
  });

  return [formData, setFormData];
};

export default useFormData;
